module.exports = __webpack_public_path__ + "6aecc713bde827dc714032ef7d5b06de.MP3";